import { Box, Button } from "@mui/material";
import _ from "lodash";
import React from "react"
import { useTranslation } from "react-i18next";
import {useNavigate} from 'react-router-dom' 
import { useRecoilState } from "recoil";
import { userState } from "../atoms";
import { userSettingDefault } from "../atoms/userSetting";
import { now } from "../framework/utils/date";
import { User } from "../models";
import apiService from "../services/api";

function ConsentMarketingPage() {
  const { t } = useTranslation()
  const navigate = useNavigate();
  const [user, setUser] = useRecoilState(userState)
  
  const getInitialUserSetting = (user: User) => {
    const rv = {...userSettingDefault}
    rv.username = user.name
    rv.insertDate = now()
    rv.updateDate = now()
    rv.language = 'it'

    return rv
  }

  const updateConsent = (consent: boolean) => (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!user) return
    const newUser = _.cloneDeep(user)
    // console.log('newUser after clone', newUser)
    if (!newUser.setting) {
      newUser.setting = getInitialUserSetting(user)
    }
    newUser.setting!.marketingConsent = consent
    
    setUser(newUser)
    //apiService.updateConsentSetting(newUser.setting!).then(() => consent ? navigate('/') : window.location.replace(constants.logoutUrl))    
    apiService.updateConsentSetting(newUser.setting!).then(() => navigate('/'))    
  }
  
  
  return (
      <Box sx={{display: 'flex', width: '100%', height: '100%', alignItems: 'center', flexDirection: 'column'}}>
        <Box>
          <h1>Acconsento a ricevute ogni news di marketing</h1>
        </Box>
        <Box sx= {{display: 'flex', gap: 2, width: '80%', justifyContent: 'space-between'}}>
          <Button onClick={updateConsent(false)} title={t('Consenso')} variant="outlined">
            Non do il Consenso
          </Button>
          <Button onClick={updateConsent(true)} title={t('Consenso')} variant="outlined">
            Do il Consenso
          </Button>
        </Box>
      </Box>

  )
}
  
export default ConsentMarketingPage;